import React, { useEffect, useState } from 'react';
import { Paper, MenuItem } from '@material-ui/core';
import { baseUrl } from '../../utils/constants';
import { useSettingContext } from '../../context/setting_context';

export default function EnterpriseSettings() {
  const { setSettingType, setSettingName } = useSettingContext();
  const [settings, setSettings] = useState([]);

  const getSettings = async () => {
    fetch(`${baseUrl}/api/setting/GetEnterpriseGroupTypes`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned enterprise settings0', result);
          console.log('returned enterprise settings1', result.lookupList);
          setSettings(result.lookupList);
        },
        (error) => {
          alert('failed');
        }
      );
  };

  useEffect(() => {
    getSettings();
  }, []);

  const handleSelect = (e, value) => {
    e.preventDefault();
    setSettingType(value.id);
    setSettingName(value.text);
    console.log('enterprise list from click', e, value);
  };

  return (
    <Paper sx={{ width: 320 }}>
      {settings.map((item, index) => (
        <MenuItem key={item.id} value={item.text} onClick={(event) => handleSelect(event, item)}>
          {item.text ?? item.id}
        </MenuItem>
      ))}
    </Paper>
  );
}
